import gql from 'graphql-tag';

export const GET_COUNTS_FOR_PROJECT_QUERY = gql`
  query GetCountsForProjectQuery($projectId: Int!) {
    counts: getCountsForProject(projectId: $projectId)
  }
`;
